<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">货品管理</el-breadcrumb-item>
        <el-breadcrumb-item>入库单详情</el-breadcrumb-item>
      </el-breadcrumb>
      <operation-help namespace="stock" help-key="inbound-audit" />
    </template>

    <div class="toolbar">
      <el-button type="info" icon="Back" @click="back()">返回</el-button>
      <el-button type="primary" icon="printer" @click="onprint('0')">打印预入库单</el-button>
      <el-button type="success" icon="printer" @click="onprint('1')">打印入库接收单</el-button>
    </div>

    <section ref="print" id="print-panel">
      <div class="title-box">
        <h3 style=" font-size: 1.6em; font-weight: 500; text-align: center;  margin: 20px auto; margin-top: 30px;">
          [{{ bill.billType }}] 入库通知单
        </h3>
        <el-row :gutter="10" style="padding: 12px">
          <el-col :xs="24" :sm="14" :md="14" :lg="14" :xl="14">
            <span style="margin-right: 20px">
              所属公司：
              <!-- <el-cascader v-model="bill.companyID" :options="companys" style="max-width:150px" :disabled="true" /> -->
              <el-tree-select ref="companys" v-model="bill.companyID" :data="companys" disabled check-strictly
                :render-after-expand="false" style="width: 200px;" />
            </span>
            <span style=" margin-right: 20px"> 类型：{{ bill.billType }} </span>
            <span style=" margin-right: 20px"> 单号：{{ bill.billCode }} </span>
            <span style=" margin-right: 20px"> 库房：{{ bill.storeCode }} </span>
            <span style=" margin-right: 20px"> 渠道：{{ bill.channelCode }} </span>
          </el-col>

          <el-col :xs="24" :sm="10" :md="10" :lg="10" :xl="10" align="right">
            <span style="margin-right: 30px"> 关联单号：{{ bill.netCode || "无" }} </span>
            <span> 时间：{{ bill.billDate }} </span>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="margin-top: 5px;" align="right">
            <span style="margin-right: 20px">
              操作：{{ bill.handoverName || "无" }}
            </span>
            <span style="margin-right: 20px">
              交接：{{ bill.reviewerName || "无" }}
            </span>
            <span style="margin-right: 20px">
              复核：{{ bill.operatorName || "无" }}
            </span>
            <span style="margin-right: 20px">
              财务：{{ bill.financerName || "无" }}
            </span>
            <span style="margin-left: 80px">
              备注：
              {{ bill.remark || "无" }}
            </span>
          </el-col>
        </el-row>
      </div>

      <el-tabs type="border-card" v-model="tabName">
        <el-tab-pane name="prestock">
          <template #label>
            <span>预入库货品 {{ prebounds.length }}</span>
          </template>

          <el-form :inline="true" v-if="bill.status == 0">
            <el-form-item label="货品条码">
              <el-input v-model="forms.keyword" @keyup.enter="auditBound" placeholder="扫码/回车键自动审核">
              </el-input>
            </el-form-item>
            <el-form-item label="数量">
              <el-input-number v-model="forms.number" @keyup.enter="auditBound" :precision="2" :step="1" :min="0"
                :max="10000" />
            </el-form-item>

            <el-form-item label="" label-width="0px" v-if="forms.keyword">
              <el-button type="primary" icon="CircleCheck" @click="auditBound">扫码审核</el-button>
            </el-form-item>

            <el-form-item label="" label-width="0" v-if="selects.length > 0">
              <el-button type="primary" icon="Select" @click="auditBatch">批量审核</el-button>
            </el-form-item>

            <el-form-item label="" label-width="0" v-if="selects.length > 0" style="float:right;">
              <el-button type="danger" icon="Select" @click="refuseBatch">取消审核</el-button>
            </el-form-item>
          </el-form>

          <el-table class="table" :data="prebounds" border style="width: 100%" highlight-current-row size="small"
            show-summary @selection-change="selectionChange">
            <el-table-column type="selection" width="50" align="center" />
            <el-table-column label="序号" type="index" width="50" align="center"> </el-table-column>
            <el-table-column prop="channel" label="渠道" width="70" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="storeName" label="库房" width="70" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="status" label="状态" align="center" width="60">
              <template #default="scope">
                <el-link v-if="scope.row.status == 0" type="primary" size="small" disabled
                  title="待确认(未入库)">待确认</el-link>
                <el-link v-else-if="scope.row.status == 1" type="success" size="small" title="已确认(已入库)"
                  disabled>已确认</el-link>
                <el-link v-else-if="scope.row.status == -1" type="danger" size="small" title="已取消"
                  disabled>已取消</el-link>
                <el-link v-else type="info" size="small" disabled>其他</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="brandSerialCode" label="批次号" align="center" sortable width="120">
              <template #default="scope">
                <el-link v-if="scope.row.status == 0" type="primary" size="small" disabled title="待确认(未入库)">{{
                  scope.row.brandSerialCode }}</el-link>
                <el-link v-else-if="scope.row.status == 1" type="success" size="small" title="已确认(已入库)" disabled>{{
                  scope.row.brandSerialCode }}</el-link>
                <el-link v-else-if="scope.row.status == -1" type="danger" size="small" title="已取消" disabled>{{
                  scope.row.brandSerialCode }}</el-link>
                <el-link v-else type="info" size="small" disabled>{{ scope.row.brandSerialCode }}</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="detailCode" label="系统款号" width="120" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="brandModelCode" label="品牌款号" width="120" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="certNumber" label="证书号" width="100" align="center"
              show-overflow-tooltip></el-table-column>

            <el-table-column prop="detailName" label="产品名称" sortable width="150" align="center"
              show-overflow-tooltip></el-table-column>

            <el-table-column prop="brandCode" label="供应商" width="70" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="detailCode" label="图片" align="center" width="70">
              <template #default="scope">
                <el-image style="height: 32px; width: 32px" lazy
                  :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
                  :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
                  <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" /></template>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="unitName" label="规格" align="center" width="65"
              show-overflow-tooltip></el-table-column>

            <el-table-column prop="className" label="计价方式" align="center" width="65"> </el-table-column>

            <el-table-column prop="stockNumber" label="数量" align="right" width="55"> </el-table-column>
            <el-table-column prop="labelPrice" label="标签价" align="right" width="65"> </el-table-column>

            <el-table-column prop="weight" label="货重(g)" align="right" width="60"> </el-table-column>

            <el-table-column prop="goldWeight" label="金重(g)" align="right" width="60"> </el-table-column>
            <el-table-column prop="goldInPrice" label="金单价" align="right" width="60"> </el-table-column>
            <el-table-column prop="goldInTaxPrice" label="含税金单价" align="right" width="82"> </el-table-column>
            <el-table-column prop="laborUnitPrice" label="克工费" align="right" width="60"> </el-table-column>
            <el-table-column prop="laborUnitTaxPrice" label="含税克工费" align="right" width="82"> </el-table-column>
            <el-table-column prop="laborPiecePrice" label="件工费" align="right" width="60"> </el-table-column>
            <el-table-column prop="laborPieceTaxPrice" label="含税件工费" align="right" width="82"> </el-table-column>

            <el-table-column prop="stoneBoundPrice" label="镶嵌物费用" align="right" width="80"> </el-table-column>
            <el-table-column prop="stoneBoundTaxPrice" label="含税镶嵌物费用" align="right" width="110"> </el-table-column>
            <el-table-column prop="otherPiecePrice" label="其他费用" align="right" width="65"> </el-table-column>
            <el-table-column prop="otherPieceTaxPrice" label="含税其他费用" align="right" width="90"> </el-table-column>

            <el-table-column prop="noTaxPurchasePrice" width="95" label="不含税采购价" align="right"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="taxPrice" width="70" label="税额" align="right"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="purchasePrice" width="90" label="含税采购价" align="right"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="useBrandPrice" width="90" label="品牌使用费" align="right"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="productPrice" width="75" align="right" label="入库价"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="sellPrice" width="70" align="right" label="售价"> </el-table-column>
            <el-table-column prop="outOrderNo" label="原单号" width="120" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="productionDate" label="生产日期" show-overflow-tooltip>
              <template #default="scope">
                {{ (scope.row.productionDate || '').split(' ')[0] }}
              </template>
            </el-table-column>
            <el-table-column prop="warrantyExpiryDate" label="有效日期" show-overflow-tooltip>
              <template #default="scope">
                {{ (scope.row.warrantyExpiryDate || '').split(' ')[0] }}
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip> </el-table-column>
            <el-table-column label="操作" width="120" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" size="small" icon="Edit" v-if="scope.row.status == '0'"
                  @click="editRow(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="instock">
          <template #label>
            <span>已审核货品 {{ bounds.length }}</span>
          </template>

          <el-table class="table" :data="bounds" border style="width: 100%" highlight-current-row size="small"
            show-summary>
            <el-table-column label="序号" type="index" width="50" align="center"> </el-table-column>
            <el-table-column prop="channel" label="渠道" width="70" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="storeCode" label="库房" width="70" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="serialCode" label="批次号" align="center" sortable width="120"> </el-table-column>
            <el-table-column prop="brandSerialCode" label="品牌批次号" align="center" sortable width="120"> </el-table-column>
            <el-table-column prop="detailCode" label="系统款号" width="130" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="brandModelCode" label="品牌款号" width="120" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="certNumber" label="证书号" width="130" align="center" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="detailName" label="产品名称" sortable width="180" align="center" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="brandCode" label="供应商" width="70" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="detailCode" label="图片" align="center" width="70">
              <template #default="scope">
                <el-image style="height: 32px; width: 32px" lazy
                  :src="apiUrl + 'static/code/' + scope.row.detailCode + '?t=0'"
                  :preview-src-list="[apiUrl + 'static/code/' + scope.row.detailCode + '?t=1']">
                  <template #error><img style="width: 100%" src="~@/assets/imgunfine.jpg" alt="" /></template>
                </el-image>
              </template>
            </el-table-column>

            <el-table-column prop="unitName" label="规格" align="center" width="65"
              show-overflow-tooltip></el-table-column>

            <el-table-column prop="className" label="计价方式" align="center" width="65"> </el-table-column>

            <el-table-column prop="stockNumber" label="数量" align="right" width="55"> </el-table-column>
            <el-table-column prop="labelPrice" label="标签价" align="right" width="65"> </el-table-column>

            <el-table-column prop="weight" label="货重(g)" align="right" width="65"> </el-table-column>

            <el-table-column prop="goldWeight" label="金重(g)" align="right" width="60"> </el-table-column>
            <el-table-column prop="goldInPrice" label="金单价" align="right" width="60"> </el-table-column>
            <el-table-column prop="goldInTaxPrice" label="含税金单价" align="right" width="82"> </el-table-column>
            <el-table-column prop="laborUnitPrice" label="克工费" align="right" width="60"> </el-table-column>
            <el-table-column prop="laborUnitTaxPrice" label="含税克工费" align="right" width="82"> </el-table-column>
            <el-table-column prop="laborPiecePrice" label="件工费" align="right" width="60"> </el-table-column>
            <el-table-column prop="laborPieceTaxPrice" label="含税件工费" align="right" width="82"> </el-table-column>

            <el-table-column prop="stoneBoundPrice" label="镶嵌物费用" align="right" width="80"> </el-table-column>
            <el-table-column prop="stoneBoundTaxPrice" label="含税镶嵌物费用" align="right" width="110"> </el-table-column>
            <el-table-column prop="otherPiecePrice" label="其他费用" align="right" width="65"> </el-table-column>
            <el-table-column prop="otherPieceTaxPrice" label="含税其他费用" align="right" width="90"> </el-table-column>

            <el-table-column prop="noTaxPurchasePrice" width="95" label="不含税采购价" align="right"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="taxPrice" width="70" label="税额" align="right"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="purchasePrice" width="90" label="含税采购价" align="right"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="useBrandPrice" width="90" label="品牌使用费" align="right"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="productPrice" width="75" align="right" label="入库价" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="sellPrice" width="75" align="right" label="售价"> </el-table-column>
            <el-table-column prop="outOrderNo" label="原单号" width="120" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="productionDate" label="生产日期" show-overflow-tooltip>
              <template #default="scope">
                {{ (scope.row.productionDate || '').split(' ')[0] }}
              </template>
            </el-table-column>
            <el-table-column prop="warrantyExpiryDate" label="有效日期" show-overflow-tooltip>
              <template #default="scope">
                {{ (scope.row.warrantyExpiryDate || '').split(' ')[0] }}
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip> </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

    </section>

    <!-- 编辑弹框 -->
    <el-dialog v-model="editDialog.visible" :title="editDialog.title" width="800px">
      <el-form :model="editDialog.form" :rules="editDialog.rules" ref="editForm" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="批次号" prop="serialCode">
              <el-input v-model="editDialog.form.serialCode" placeholder="请输入批次号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="规格" prop="unitName">
              <el-input v-model="editDialog.form.unitName" placeholder="请输入规格"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="单价" prop="unitPrice">
              <el-input-number v-model="editDialog.form.unitPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入单价"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标签价" prop="labelPrice">
              <el-input-number v-model="editDialog.form.labelPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入标签价"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="货重(g)" prop="weight">
              <el-input-number v-model="editDialog.form.weight" :precision="2" :step="0.01" :min="0" style="width: 100%"
                placeholder="请输入货重"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="金重(g)" prop="goldWeight">
              <el-input-number v-model="editDialog.form.goldWeight" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入金重"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider style="margin-top: 0;" />
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="金单价" prop="goldInPrice">
              <el-input-number v-model="editDialog.form.goldInPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入金单价"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="含税金单价" prop="goldInTaxPrice">
              <el-input-number v-model="editDialog.form.goldInTaxPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入含税金单价"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="克工费" prop="laborUnitPrice">
              <el-input-number v-model="editDialog.form.laborUnitPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入克工费"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="件工费" prop="laborPiecePrice">
              <el-input-number v-model="editDialog.form.laborPiecePrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入件工费"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="含税克工费" prop="laborUnitTaxPrice">
              <el-input-number v-model="editDialog.form.laborUnitTaxPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入含税克工费"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="含税件工费" prop="laborPieceTaxPrice">
              <el-input-number v-model="editDialog.form.laborPieceTaxPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入含税件工费"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="镶嵌物费用" prop="stoneBoundPrice">
              <el-input-number v-model="editDialog.form.stoneBoundPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入镶嵌物费用"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="含税镶嵌物费用" prop="stoneBoundTaxPrice">
              <el-input-number v-model="editDialog.form.stoneBoundTaxPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入含税镶嵌物费用"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="其他费用" prop="otherPiecePrice">
              <el-input-number v-model="editDialog.form.otherPiecePrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入其他费用"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="含税其他费用" prop="otherPieceTaxPrice">
              <el-input-number v-model="editDialog.form.otherPieceTaxPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入含税其他费用"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider style="margin-top: 0;" />
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="不含税采购价" prop="noTaxPurchasePrice">
              <el-input-number v-model="editDialog.form.noTaxPurchasePrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入不含税采购价" @change="calculatePurchasePrice"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税额" prop="taxPrice">
              <el-input-number v-model="editDialog.form.taxPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入税额" @change="calculatePurchasePrice"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="含税采购价" prop="purchasePrice">
              <el-input-number v-model="editDialog.form.purchasePrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入含税采购价" disabled></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="品牌使用费" prop="useBrandPrice">
              <el-input-number v-model="editDialog.form.useBrandPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入品牌使用费" @change="calculateProductPrice"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入库价" prop="productPrice">
              <el-input-number v-model="editDialog.form.productPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入入库价" disabled></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="售价" prop="sellPrice">
              <el-input-number v-model="editDialog.form.sellPrice" :precision="2" :step="0.01" :min="0"
                style="width: 100%" placeholder="请输入售价"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider style="margin-top: 0;" />
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="原单号" prop="outOrderNo">
              <el-input v-model="editDialog.form.outOrderNo" placeholder="请输入原单号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产日期" prop="productionDate">
              <el-date-picker v-model="editDialog.form.productionDate" type="date" placeholder="选择生产日期"
                style="width: 100%" value-format="YYYY-MM-DD"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="有效日期" prop="warrantyExpiryDate">
              <el-date-picker v-model="editDialog.form.warrantyExpiryDate" type="date" placeholder="选择有效日期"
                style="width: 100%" value-format="YYYY-MM-DD"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="editDialog.form.remark" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="editDialog.visible = false">取消</el-button>
          <el-button type="primary" @click="saveEdit">保存</el-button>
        </span>
      </template>
    </el-dialog>
  </el-card>
</template>
<script>
import printJS from "print-js";
import { fetchBillByCode, auditBoundIn, refuseBoundIn } from "@/api/stock";
import { findCompanyById } from "@/api/basic";
export default {
  name: "billInDetail",
  components: {},
  data() {
    return {
      apiUrl: '',
      billCode: null,
      bill: {},
      bounds: [],
      prebounds: [],

      forms: {
        keyword: '',
        number: 1,
      },
      tabName: "prestock",
      dict: {
        inBillTypes: [],
      },

      companys: [],
      companyName: '',
      selects: [],

      // 编辑弹框相关
      editDialog: {
        visible: false,
        title: '编辑货品信息',
        form: {},
        rules: {
          serialCode: [{ required: true, message: '请输入批次号', trigger: 'blur' }],
          goldWeight: [{ required: true, message: '请输入金重', trigger: 'blur' }],
          noTaxPurchasePrice: [{ required: true, message: '请输入不含税采购价', trigger: 'blur' }],
          purchasePrice: [{ required: true, message: '请输入含税采购价', trigger: 'blur' }],
          productPrice: [{ required: true, message: '请输入入库价', trigger: 'blur' }],
          // unitPrice: [
          //   { required: true, message: '请输入单价', trigger: 'blur' },
          //   { pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/, message: '请输入合法的金额数字，最多两位小数', trigger: 'blur' }
          // ],
        },
      },
    };
  },
  methods: {
    loadData() {
      fetchBillByCode(this.billCode).then((res) => {
        let that = this;
        if (res.code == 200) {
          this.bill = res.data.bill;
          this.billCode = this.bill.billCode;
          const company = findCompanyById(this.bill.companyID, this.companys);
          this.companyName = company ? company.companyName : '';

          this.bounds = res.data.bounds;
          this.prebounds = res.data.prebounds;
          this.title = res.data.title;

          //   var sumNumber = 0; var sumWeight = 0; var sumPurchasePrice = 0;
          //   for (let i = 0; i < this.bounds.length; i++) {
          //     sumNumber += parseFloat(this.bounds[i].stockNumber);
          //     sumWeight += parseFloat(this.bounds[i].weight);
          //     sumPurchasePrice += parseFloat(this.bounds[i].purchasePrice);
          //   }
          //   this.bounds.push({
          //     channel: '【合计】',
          //     stockNumber: sumNumber.toFixed(2),
          //     weight: sumWeight.toFixed(2),
          //     purchasePrice: sumPurchasePrice.toFixed(2),
          //   });


          //   var sumNumber1 = 0; var sumWeight1 = 0; var sumPurchasePrice1 = 0;
          //   for (let i = 0; i < this.prebounds.length; i++) {
          //     sumNumber1 += parseFloat(this.prebounds[i].stockNumber);
          //     sumWeight1 += parseFloat(this.prebounds[i].weight);
          //     sumPurchasePrice1 += parseFloat(this.prebounds[i].purchasePrice);
          //   }
          //   this.prebounds.push({
          //     channel: '【合计】',
          //     stockNumber: sumNumber1.toFixed(2),
          //     weight: sumWeight1.toFixed(2),
          //     purchasePrice: sumPurchasePrice1.toFixed(2),
          //   })
        }
      });
    },
    back() {
      this.$router.go(-1);
    },
    //打印
    onprint(printType) {
      // let noprints = document.getElementsByClassName("caret-wrapper");
      // for (let i = 0; i < noprints.length; i++) {
      //   noprints[i].style.display = "none";
      // }

      // printJS({
      //   printable: "print-panel",
      //   type: "html",
      //   style:
      //     ".el-table td, .el-table th.is-leaf { border-bottom:1px solid #EBEEF5; }",
      // });


      //console.log(this.bill.companyId)
      let printData = [];

      let dataitems = [];
      if (printType == '1') dataitems = this.bounds;
      else if (printType == '0') dataitems = this.prebounds;

      let total = 0;
      for (let i = 0; i < dataitems.length; i++) {
        let row = dataitems[i];
        if ((row.detailName || '') == '') continue;

        total += row.stockNumber;
        printData.push({
          '序号': (i + 1),
          '渠道': row.channel,
          '库房': row.storeName || row.storeCode,
          '系统款号': row.detailCode,
          '品牌款号': (row.brandModelCode || ''),
          '批次号': (row.brandSerialCode || ''),
          '名称': this.spitOmit(row.detailName || '', 15),
          '数量': row.stockNumber,
          '货重': row.weight,
          '金重': row.goldWeight,
          '规格': row.unitName,
          '备注': (row.remark || '')
        });
      }

      let title = this.companyName + "<span style='float:right'>" + this.bill.billDate + "</span>" + "<br>";
      title += '[' + this.bill.billType + ']';

      if (printType == '1') title += " 正式入库单 ";
      else if (printType == '0') title += " 预入库单 ";

      title += "(货品" + dataitems.length + "件,合计数量" + total + "个) " + "<span style='float:right'>" + this.bill.billCode + "</span>";
      title += "<br>";

      title += "<span style='font-size:0.5em;float:right; margin-bottom:10px;'>";
      title += "[操作： " + (this.bill.handoverName || this.bill.createUserName) + "]、";
      title += "[交接： " + (this.bill.reviewerName || "无") + "]、";
      title += "[复核： " + (this.bill.operatorName || "无") + "]、";
      title += "[财务： " + (this.bill.financerName || "无") + "] ";
      title += "</span>";

      printJS({
        header: '<h3 class="">' + title + '</h3>',
        printable: printData,
        properties: ['序号', '渠道', '库房', '系统款号', '品牌款号', '批次号', '名称', '数量', '货重', '金重', '规格', '备注'],
        type: 'json',
        gridHeaderStyle: 'font-size:0.4em;font-weight:bold;border: 1px solid #ccc;white-space:nowrap',
        gridStyle: 'padding:1px 2px;',
        style: 'table tr td{font-size:0.4em;border: 1px solid #ccc;text-align:center;white-space:nowrap }'
      })
    },
    spitBr(str, len) {
      let restr = '';
      len = len || 10;
      let i = 1;
      while (str.length > len) {
        restr += str.substr(0, len) + '<br>';
        str = str.substr(len, str.length);
        i++;
      }
      restr += str;
      return restr;
    },
    spitOmit(str, len) {
      return (str || '').length > (len || 10) ? str.substr(0, len || 10) + "…" : str;
    },
    toNumber(val) {
      const num = Number(val);
      return Number.isFinite(num) ? num : 0;
    },
    validateTaxFields(row) {
      if (!row.serialCode) {
        return '请填写货品的批次号信息';
      }

      if (!row.goldWeight && row.goldWeight !== 0) {
        return '请填写货品的金重（无金材质货品请填写0）';
      }

      if ((row.goldWeight || 0) < 0) {
        return '金重不能为负数';
      }

      if (row.goldWeight > 0 && (row.goldInPrice || 0) <= 0) {
        return '请填写入库货品的入库金单价';
      }

      if (row.goldWeight > 0 && (row.laborPiecePrice || 0) <= 0 && (row.laborUnitPrice || 0) <= 0) {
        return '请填写入库克工费或件工费';
      }

      if ((row.goldWeight || 0) > (row.weight || 0)) {
        return '货品的金重不可以大于货品总重量';
      }

      if (!row.noTaxPurchasePrice || row.noTaxPurchasePrice <= 0) {
        return '请填写不含税采购价';
      }

      if (!row.purchasePrice || row.purchasePrice <= 0) {
        return '请填写含税采购价';
      }

      if (!row.sellPrice || row.sellPrice <= 0) {
        return '请填写入库货品的售价信息';
      }

      const checks = [
        { tax: "goldInTaxPrice", base: "goldInPrice", label: "含税金单价" },
        { tax: "laborUnitTaxPrice", base: "laborUnitPrice", label: "含税克工费" },
        { tax: "laborPieceTaxPrice", base: "laborPiecePrice", label: "含税件工费" },
        { tax: "otherPieceTaxPrice", base: "otherPiecePrice", label: "含税其他费用" },
        { tax: "stoneBoundTaxPrice", base: "stoneBoundPrice", label: "含税镶嵌物费用" },
      ];
      for (const item of checks) {
        if (row[item.tax] != null && row[item.tax] !== "" && this.toNumber(row[item.tax]) < this.toNumber(row[item.base])) {
          return `${item.label}必须大于等于对应不含税字段`;
        }
      }
      return "";
    },
    auditBound() {
      let that = this;
      if (!this.forms.keyword || this.forms.number <= 0) {
        this.$message.error("审核失败，请输入正确的货号及数量");
        return;
      }
      this.forms.keyword = (this.forms.keyword || '').toUpperCase();
      let details = this.prebounds.filter(function (q) { return q.brandSerialCode == that.forms.keyword || q.serialCode == that.forms.keyword });
      if (details.length == 0) {
        this.$message.error("审核失败，未找到该货品批次号");
        return;
      }
      details = details.filter(function (q) { return q.stockNumber == that.forms.number });
      if (details.length == 0) {
        this.$message.error("审核失败，该货品批次号对应数量错误，请检查入库数量和实际货品数量");
        return;
      }
      let detail = details[0];
      let params = [{
        brandSerialCode: detail.brandSerialCode,
        serialCode: detail.serialCode,
        stockNumber: detail.stockNumber,
        id: detail.id
      }];
      auditBoundIn(this.billCode, params).then((res) => {
        that.$message({ type: res.type, message: res.content, });
        if (res.code == 200) {
          that.forms.keyword = '';
          that.forms.number = 1;

          // 智能更新页面数据，匹配部分数据
          if (res.data) {
            that.updatePartialData(res.data);
          } else {
            // 如果后端没有返回数据，则保持原有逻辑
            that.loadData();
          }
        }
      });
    },
    auditBatch() {
      let that = this;
      let rows = this.selects.filter(function (q) { return q.status == 0; });
      if (rows.length == 0) {
        this.$message.error("审核失败，请勾选未审核货品");
        return;
      }

      let params = [];
      rows.forEach(function (item) {
        params.push({
          brandSerialCode: item.brandSerialCode,
          serialCode: item.serialCode,
          stockNumber: item.stockNumber,
          id: item.id
        });
      });
      auditBoundIn(this.billCode, params).then((res) => {
        that.$message({ type: res.type, message: res.content, });
        if (res.code == 200) {
          that.forms.keyword = '';
          that.forms.number = 1;

          // 智能更新页面数据，匹配部分数据
          if (res.data) {
            that.updatePartialData(res.data);
          } else {
            // 如果后端没有返回数据，则保持原有逻辑
            that.loadData();
          }
        }
      });
    },
    refuseBatch() {
      let that = this;
      let rows = this.selects.filter(function (q) { return q.status == 0; });
      if (rows.length == 0) {
        this.$message.error("审核失败，请勾选未审核货品");
        return;
      }

      let params = [];
      rows.forEach(function (item) {
        params.push({
          id: item.id
        });
      });
      refuseBoundIn(this.billCode, params).then((res) => {
        that.$message({ type: res.type, message: res.content, });
        if (res.code == 200) {
          that.forms.keyword = '';
          that.forms.number = 1;

          // 智能更新页面数据，匹配部分数据
          if (res.data) {
            that.updatePartialData(res.data);
          } else {
            // 如果后端没有返回数据，则保持原有逻辑
            that.loadData();
          }
        }
      });
    },
    selectionChange(rows) {
      this.selects = rows;
    },

    // 打开编辑弹框
    editRow(row) {
      // 保存原始row数据
      this.editDialog.originalRow = { ...row };

      this.editDialog.form = {
        id: row.id,
        serialCode: row.serialCode,
        unitName: row.unitName,
        unitPrice: row.unitPrice,
        labelPrice: row.labelPrice,
        weight: row.weight,
        goldWeight: row.goldWeight,
        goldInPrice: row.goldInPrice,
        goldInTaxPrice: row.goldInTaxPrice != null ? row.goldInTaxPrice : row.goldInPrice,
        laborUnitPrice: row.laborUnitPrice,
        laborUnitTaxPrice: row.laborUnitTaxPrice != null ? row.laborUnitTaxPrice : row.laborUnitPrice,
        laborPiecePrice: row.laborPiecePrice,
        laborPieceTaxPrice: row.laborPieceTaxPrice != null ? row.laborPieceTaxPrice : row.laborPiecePrice,
        stoneBoundPrice: row.stoneBoundPrice,
        stoneBoundTaxPrice: row.stoneBoundTaxPrice != null ? row.stoneBoundTaxPrice : row.stoneBoundPrice,
        otherPiecePrice: row.otherPiecePrice,
        otherPieceTaxPrice: row.otherPieceTaxPrice != null ? row.otherPieceTaxPrice : row.otherPiecePrice,
        noTaxPurchasePrice: row.noTaxPurchasePrice,
        taxPrice: row.taxPrice,
        purchasePrice: row.purchasePrice,
        useBrandPrice: row.useBrandPrice,
        productPrice: row.productPrice,
        sellPrice: row.sellPrice,
        outOrderNo: row.outOrderNo,
        productionDate: (row.productionDate || '').split(' ')[0],
        warrantyExpiryDate: (row.warrantyExpiryDate || '').split(' ')[0],
        remark: row.remark,
      };
      this.editDialog.visible = true;
    },

    // 计算含税采购价
    calculatePurchasePrice() {
      const noTaxPrice = this.editDialog.form.noTaxPurchasePrice || 0;
      const taxPrice = this.editDialog.form.taxPrice || 0;
      this.editDialog.form.purchasePrice = parseFloat((noTaxPrice + taxPrice).toFixed(2));
      // 同时更新入库价
      this.calculateProductPrice();
    },

    // 计算入库价
    calculateProductPrice() {
      const purchasePrice = this.editDialog.form.purchasePrice || 0;
      const useBrandPrice = this.editDialog.form.useBrandPrice || 0;
      this.editDialog.form.productPrice = parseFloat((purchasePrice + useBrandPrice).toFixed(2));
    },

    // 保存编辑
    saveEdit() {
      // 先计算含税采购价
      this.editDialog.form.purchasePrice = parseFloat(((this.editDialog.form.noTaxPurchasePrice || 0) + (this.editDialog.form.taxPrice || 0)).toFixed(2));

      this.$refs.editForm.validate((valid) => {
        if (!valid) {
          this.$message.error('请检查表单填写是否正确');
          return;
        }

        const taxMessage = this.validateTaxFields(this.editDialog.form);
        if (taxMessage) {
          this.$message.error(taxMessage);
          return;
        }

        // 计算入库价（采购价 + 品牌使用费）
        this.editDialog.form.productPrice = parseFloat(((this.editDialog.form.purchasePrice || 0) + (this.editDialog.form.useBrandPrice || 0)).toFixed(2));

        const id = this.editDialog.form.id;

        // 合并原始row数据和修改后的form数据
        const submitData = {
          ...this.editDialog.originalRow,
          ...this.editDialog.form
        };

        // 处理日期字段，空字符串转为null
        if (submitData.productionDate === '' || !submitData.productionDate) {
          submitData.productionDate = null;
        }
        if (submitData.warrantyExpiryDate === '' || !submitData.warrantyExpiryDate) {
          submitData.warrantyExpiryDate = null;
        }

        this.$kaung.fetch({
          url: `StockBoundTemp/${id}`,
          method: 'put',
          data: submitData
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success('保存成功');
            this.editDialog.visible = false;

            // 更新表格数据
            const index = this.prebounds.findIndex(item => item.id === id);
            if (index !== -1) {
              Object.assign(this.prebounds[index], this.editDialog.form);
            }
          } else {
            this.$message.error(res.content || '保存失败');
          }
        }).catch((err) => {
          this.$message.error('保存失败：' + (err.message || '网络错误'));
        });
      });
    },

    // 智能更新部分数据
    updatePartialData(data) {
      // 更新预入库数据 - 只通过id匹配
      if (data.prebounds && Array.isArray(data.prebounds)) {
        data.prebounds.forEach(updatedItem => {
          const index = this.prebounds.findIndex(item =>
            item.id === updatedItem.id
          );
          if (index !== -1) {
            // 更新现有项目
            this.prebounds[index] = updatedItem;
          }
        });
      }

      // 更新已审核数据 - 直接新增push
      if (data.bounds && Array.isArray(data.bounds)) {
        data.bounds.forEach(newItem => {
          // 直接新增到bounds数组
          this.bounds.push(newItem);
        });
      }
    }
  },
  mounted() { },
  created() {
    this.apiUrl = process.env.VUE_APP_BASEURL;

    this.$kaung.dictionary("stock", "inbound").then((res) => {
      this.dict.inBillTypes = res;
    });

    this.$kaung.companys().then((res) => {
      this.companys = res;
    });

    this.billCode = this.$route.query.billCode || this.$route.query.id;
    this.loadData();
  },
  watch: {

  },
};
</script>
<style scoped>
.title-box {
  border: 1px solid #dcdfe6;
  border-bottom: 0;
}
</style>
